import { createFileRoute } from '@tanstack/react-router';
import { SectionOne } from '~/components/home-sections/SectionOne';
import { SectionTwo } from '~/components/home-sections/SectionTwo';
import { SectionThree } from '~/components/home-sections/SectionThree';
import { SectionFour } from '~/components/home-sections/SectionFour';
import { SectionFive } from '~/components/home-sections/SectionFive';
import { SectionSix } from '~/components/home-sections/SectionSix';

export const Route = createFileRoute('/')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<SectionOne />
			<SectionTwo />
			<SectionThree />
			<SectionFour />
			<SectionFive />
			<SectionSix />
		</>
	);
}
